// Product gallery: thumbnails and prev/next commands drive a scroll-snap track of slides.
class SProductGallery extends HTMLElement {
  #abort = null;
  #observer = null;
  #slides = [];
  #thumbs = [];
  #index = 0;

  connectedCallback() {
    this.#abort = new AbortController();
    const track = this.querySelector('[data-gallery-track]');
    if (!track) return;
    this.#slides = Array.from(track.querySelectorAll('[data-gallery-slide]'));
    this.#thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));

    this.addEventListener('command', (event) => this.#onCommand(event), { signal: this.#abort.signal });

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.#setActive(this.#slides.indexOf(entry.target));
          }
        }
      },
      { root: track, threshold: 0.6 }
    );
    this.#slides.forEach((slide) => this.#observer.observe(slide));
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#observer?.disconnect();
  }

  #onCommand(event) {
    const total = this.#slides.length;
    if (!total) return;
    if (event.command === '--next') {
      this.#goTo((this.#index + 1) % total);
    } else if (event.command === '--prev') {
      this.#goTo((this.#index - 1 + total) % total);
    } else if (event.command === '--go') {
      const target = Number(event.source?.dataset.index);
      if (!Number.isNaN(target)) this.#goTo(target);
    }
  }

  #goTo(index) {
    const slide = this.#slides[index];
    if (!slide) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slide.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
    this.#setActive(index);
  }

  #setActive(index) {
    if (index < 0) return;
    this.#index = index;
    this.#thumbs.forEach((thumb, i) => {
      if (i === index) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('s-product-gallery')) {
  customElements.define('s-product-gallery', SProductGallery);
}
